import { z } from "zod";
export const kioskTwinReportSchema = z.object({
    rendererId: z.string().regex(/^sha256:[0-9a-f]{64}$/u),
    widthPx: z.number().int().min(320).max(16_384),
    heightPx: z.number().int().min(320).max(16_384),
}).strict();
export const KIOSK_TWIN_HEADER = "X-Digital-Signage-Kiosk-Twin";
export const fleetTwinSchema = z.object({
    deviceId: z.uuid(),
    screen: z.object({ id: z.uuid(), name: z.string(), widthPx: z.number().int(), heightPx: z.number().int() }).strict(),
    basis: z.enum(["applied", "published"]),
    observedAt: z.iso.datetime({ offset: true }),
    lastSeenAt: z.iso.datetime({ offset: true }).nullable(),
    freshness: z.enum(["recent", "stale", "never_reported"]),
    operatingMode: z.string().nullable(),
    contentRendering: z.boolean().nullable(),
    imageVersion: z.string().nullable(),
    appliedManifestVersion: z.number().int().nullable(),
    appliedConfigVersion: z.number().int().nullable(),
    manifestSha256: z.string().nullable(),
    publicationId: z.uuid().nullable(),
    appliedPublicationId: z.uuid().nullable(),
    bundleSha256: z.string().nullable(),
    latestPublicationId: z.uuid().nullable(),
    latestBundleSha256: z.string().nullable(),
    rendererId: z.string().nullable(),
    runtimeAvailable: z.boolean(),
    availability: z.enum(["available", "not_reported", "inactive", "unsupported_renderer", "missing_manifest", "missing_experience", "media_unavailable"]),
    snapshotId: z.string().nullable(),
    document: z.string().nullable(),
    capture: z.object({ status: z.literal("unsupported") }).strict(),
}).strict();
//# sourceMappingURL=fleet-twin.js.map